import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import DefiSidebar from '../sidebar/DefiSidebar';
import DefiHeader from '../header/DefiHeader';
import { withStyles } from '@material-ui/core/styles';
import { fromJS } from 'immutable';

var nullify = function nullify() {
  return null;
};

var styles = function styles() {
  return {
    container: {
      height: '100%'
    },
    default: {
      height: '100%'
    },
    padding: {
      marginTop: 78,
      padding: 10
    },
    push: {
      marginLeft: 300
    }
  };
};

var DefiLayout =
/*#__PURE__*/
function (_Component) {
  _inherits(DefiLayout, _Component);

  function DefiLayout(props) {
    var _this;

    _classCallCheck(this, DefiLayout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DefiLayout).call(this, props));

    _this.setMediaData = function () {
      if (_this.props.sidebarContent) {
        _this.setState({
          open: _this.mql.matches,
          mobile: !_this.mql.matches
        });
      } else {
        _this.setState({
          mobile: !_this.mql.matches
        });
      }
    };

    _this.toggleSidebar = function (bool) {
      if (bool !== undefined) {
        return _this.setState({
          open: bool
        });
      }

      _this.setState({
        open: !_this.state.open
      });
    };

    _this.renderSidebar = function () {
      if (_this.props.sidebarContent) {
        return React.createElement(DefiSidebar, {
          open: _this.state.open
        }, _this.props.sidebarContent);
      }
    };

    _this.mql = window.matchMedia("(min-width: ".concat(props.mobileWidth, "px)"));
    _this.state = {
      open: false,
      mobile: !_this.mql.matches
    };
    return _this;
  }

  _createClass(DefiLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (localStorage.mobile === 'false') {
        return this.setState({
          open: true,
          mobile: false
        });
      }

      this.mql.addListener(this.setMediaData);
      this.setMediaData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.mobileWidth !== this.props.mobileWidth) {
        if (localStorage.mobile !== 'false') {
          this.mql.removeListener(this.setMediaData);
          this.mql = window.matchMedia("(min-width: ".concat(this.props.mobileWidth, "px)"));
          this.mql.addListener(this.setMediaData);
          this.setMediaData();
        }
      }

      if (!this.props.sidebarContent && this.state.open) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mql.removeListener(this.setMediaData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          headerClick = _this$props.headerClick,
          headerCenter = _this$props.headerCenter,
          headerLinks = _this$props.headerLinks,
          mobileWidth = _this$props.mobileWidth,
          sidebarContent = _this$props.sidebarContent,
          logo = _this$props.logo,
          logoLink = _this$props.logoLink,
          children = _this$props.children,
          noPadding = _this$props.noPadding,
          headerContainerClass = _this$props.headerContainerClass,
          defaultClass = _this$props.defaultClass,
          hideHeaderSidebar = _this$props.hideHeaderSidebar;
      var _this$state = this.state,
          open = _this$state.open,
          mobile = _this$state.mobile;
      var hideHeaderSidebarContent = hideHeaderSidebar == true;
      var contentClickProp = mobile && open && {
        onClick: function onClick() {
          return _this2.toggleSidebar(false);
        }
      };
      var push = open && !mobile && !hideHeaderSidebarContent ? classes.push : '';
      var padding = noPadding ? '' : classes.padding;
      return React.createElement("div", {
        className: classes.container,
        "data-testid": "defi-layout"
      }, !hideHeaderSidebarContent && React.createElement(DefiHeader, {
        toggleSidebar: sidebarContent ? this.toggleSidebar : null,
        headerClick: headerClick,
        center: headerCenter,
        right: headerLinks,
        mobileWidth: mobileWidth,
        logo: logo,
        logoLink: logoLink,
        headerContainerClass: headerContainerClass
      }), !hideHeaderSidebarContent && this.renderSidebar(), React.createElement("div", Object.assign({
        className: "".concat(classes.default, " ").concat(padding, " ").concat(push, " ").concat(defaultClass)
      }, contentClickProp), children));
    }
  }]);

  return DefiLayout;
}(Component);

DefiLayout.defaultProps = {
  headerLinks: fromJS([]),
  sidebarContent: null,
  headerCenter: null,
  mobileWidth: 1250,
  children: null,
  headerClick: nullify,
  logo: '',
  logoLink: '',
  noPadding: false
};
export default withStyles(styles)(DefiLayout);